import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService, UserData } from '@app/core/features/auth';
import { MyChartsService } from '@app/core/features/charts-manager/my-charts/my-charts.service';
import { TransferChartsPayload } from '@app/core/features/charts-manager/my-charts/transfer-charts';
import { TransferChartsService } from '@app/core/features/charts-manager/my-charts/transfer-charts/transfer-charts.services';
import { getRandomNumber } from '@app/utils';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-transfer-ownership-dialog',
  templateUrl: './transfer-ownership-dialog.component.html',
  styleUrls: ['./transfer-ownership-dialog.component.scss']
})
export class TransferOwnershipDialogComponent implements OnInit {
  form: FormGroup;
  transferChartForm: FormGroup;
  submitted = false;
  isEmailMatching = true;
  isDealerEmail = false;
  userData: UserData;

  constructor(
    public dialogRef: MatDialogRef<TransferOwnershipDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public transferChartService: TransferChartsService,
    private myChartsService: MyChartsService,
    protected toastr: ToastrService,
    private authService: AuthService,
  ) {
    dialogRef.disableClose = true;
    this.authService.userData$.subscribe(userData => this.userData = userData);
  }

  ngOnInit() {
    this.setUpForm();

    this.transferChartForm.controls.confirmEmail.valueChanges.subscribe(() => {
      this.isEmailMatching = true;
    });

    this.transferChartForm.controls.email.valueChanges.subscribe(() => {
      this.isDealerEmail = false;
    });
  }


  private setUpForm = (): void => {
    this.transferChartForm = new FormGroup({
      email: new FormControl(null, [Validators.required, Validators.email]),
      confirmEmail: new FormControl(null, [Validators.required, Validators.email]),
      message: new FormControl(null),
    });
  }


  transfer() {
    this.submitted = true;

    if (this.transferChartForm.invalid) {
      return;
    }

    if (this.transferChartForm.value.email !== this.transferChartForm.value.confirmEmail) {
      this.isEmailMatching = false;
      return;
    }


    if (this.transferChartForm.value.email === this.userData.email) {
      this.isDealerEmail = true;
      return;
    }

    const payload: TransferChartsPayload = {
      email: this.transferChartForm.value.confirmEmail,
      message: this.transferChartForm.value.message,
      chartEntitlementIds: this.data.listChildChartEntitlementId
    };

    this.transferChartService.startTransferChart(payload).subscribe(res => {
      if (res instanceof HttpErrorResponse) {
        this.toastr.error(res.message);
      } else if (res && res.result === true) {
        this.myChartsService.checkChangedMyListCharts.next(getRandomNumber());
      }
      this.dialogRef.close();
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  get f(): { [key: string]: AbstractControl } {
    return this.transferChartForm.controls;
  }

}
